/* eslint-disable */

import React, { useState } from 'react';
import axios from 'axios';
import { Box, IconButton, Tooltip, Modal, Button } from '@mui/material';
import {
  CloseRounded,
  DescriptionRounded,
  FileDownloadRounded,
  UploadFileRounded,
  VisibilityRounded,
} from '@mui/icons-material';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import Key from '../../../clientVariables.json';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';

const ViewContract = () => {
  const [open, setOpen] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  const selectedCustomerDetails = useSelector((state) => state.contractsManagement.selectedContract);

  const handleView = async () => {
    const customerId = selectedCustomerDetails?.customer_id;
    const fileName = selectedCustomerDetails?.file_name || selectedCustomerDetails?.contract_filename;
    console.log('view selectedCustomerDetails', selectedCustomerDetails);
    try {
      const response = await axios.get(`${Key.domain}/payment/contract/${customerId}/${fileName}`, {
        responseType: 'blob',
      });

      const blob = new Blob([response.data], { type: response.headers['content-type'] });
      const url = window.URL.createObjectURL(blob);

      setPdfUrl(url);
      setOpen(true);
    } catch (error) {
      console.error('Error viewing file:', error);
      if (!selectedCustomerDetails) {
        toast.error('Select Customer');
      } else if (!selectedCustomerDetails?.file_name) {
        toast.error('Create Agreement');
      }
    }
  };

  const handleClose = () => {
    setOpen(false);
    if (pdfUrl) {
      window.URL.revokeObjectURL(pdfUrl);
    }
  };

  const handleDownload = async () => {
    const customerId = selectedCustomerDetails?.customer_id;
    const fileName = selectedCustomerDetails?.file_name || selectedCustomerDetails?.contract_filename;

    try {
      const response = await axios.get(`${Key.domain}/payment/contract/${customerId}/${fileName}`, {
        responseType: 'blob',
      });

      const blob = new Blob([response.data], { type: response.headers['content-type'] });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();

      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error downloading file:', error, selectedCustomerDetails);

      if (!selectedCustomerDetails) {
        toast.error('Select Customer');
      } else if (!selectedCustomerDetails?.file_name) {
        toast.error('Create Agreement');
      }
    }
  };

  return (
    <>
      <Box sx={{ display: 'flex', gap: '2px', ml: '5px' }}>
        <Tooltip followCursor title="View Contract">
          <IconButton onClick={handleView}>
            <VisibilityRounded />
          </IconButton>
        </Tooltip>
        <Tooltip followCursor title="Download Contract">
          <IconButton onClick={handleDownload}>
            <FileDownloadRounded />
          </IconButton>
        </Tooltip>
      </Box>

      <Modal open={open} onClose={handleClose} sx={{ mt: '80px' }}>
        <Box
          sx={{
            width: '80vw',
            height: '80vh',
            overflow: 'auto',
            margin: 'auto',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
          }}
        >
          {pdfUrl ? (
            <Worker
              workerUrl={`https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.min.js`}
              //  workerUrl={`https://unpkg.com/pdfjs-dist@${window['pdfjs-dist/build/pdf'].version}/build/pdf.worker.min.js`}
            >
              <Viewer fileUrl={pdfUrl} />
            </Worker>
          ) : (
            <p>Loading...</p>
          )}
          <Button variant="contained" onClick={handleClose} sx={{ position: 'absolute', bottom: '20px' }}>
            Close
          </Button>
        </Box>
      </Modal>
    </>
  );
};

export default ViewContract;
